import {api} from '@/lib/api';
import {AppData} from "@/data/app-data-interfaces";

export async function getAppData(): Promise<AppData> {
    const xhr = await api.get<{ data: AppData }>('/app-data');
    return xhr.data.data;
}

export async function getVideoUrl(videoId: string) {
    const xhr = await api.get<{ url: string }>(`/app-data/video-url/${videoId}`);
    return xhr.data.url;
}

export async function createWebToken(): Promise<string> {
    const xhr = await api.post<{ webTokenId: string }>('/app-data/web-token');
    return xhr.data.webTokenId;
}

export async function getWebToken(webTokenId: string): Promise<string> {
    const xhr = await api.get<{ token: string }>(`/app-data/web-token/${webTokenId}`, {
        skipAuthRefresh: true, // This endpoint doesn't require authentication
    } as any);
    return xhr.data.token;
}

export async function getImpersonateToken(email: string): Promise<string> {
    const xhr = await api.post<{
        token: string
    }>('/app-data/impersonate-token', {email}, {skipAuthRefresh: true} as any);
    return xhr.data.token;
}
